import { useState } from 'react';

// third-party
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { IconLogout } from '@tabler/icons';
import { useSnackbar } from 'notistack';
import { useLocation, useNavigate } from 'react-router-dom';

// material-ui
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// project imports
import { useAuth } from 'context/authContext';
import useScriptRef from 'hooks/useScriptRef';

function ButtonLogout() {
    const location = useLocation();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    const auth = useAuth();
    const [loading, setLoading] = useState(false);
    const scriptedRef = useScriptRef();

    const handleTraditionalLogout = async () => {
        setLoading(true);
        auth.signout?.(() => {
            setLoading(false);
            navigate('/login', { state: { from: location } });
        });
    };

    const handleMsalLogout = () => {
        setLoading(true);
        instance
            .logoutRedirect({
                account: instance.getActiveAccount() || accounts[0],
                onRedirectNavigate: () => false,
            })
            .then(() => {
                localStorage.clear();
                navigate('/login', { state: { from: location } });
            })
            .catch((error) => {
                enqueueSnackbar(`MSAL Logout Error: ${error?.errorMessage}`, { variant: 'error' });
            })
            .finally(() => {
                if (scriptedRef.current) {
                    setLoading(true);
                }
            });
    };

    return (
        <ListItemButton
            disabled={loading}
            onClick={isAuthenticated ? handleMsalLogout : handleTraditionalLogout}
            sx={{ borderRadius: '10px' }}
        >
            <ListItemIcon>
                <IconLogout stroke={1.5} size="1.3rem" />
            </ListItemIcon>
            <ListItemText primary="Logout" primaryTypographyProps={{ variant: 'body2' }} />
        </ListItemButton>
    );
}

export default ButtonLogout;
